// removed by extract-text-webpack-plugin
module.exports = {"container":"_22d8rsWZpwY5UVHLHAwyGh"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsReminders/StatisticsReminders.scss
// module id = 1387
// module chunks = 1